import { graphql } from 'gatsby'
import React, { type ReactElement } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import Animation from '@/components/animation/animation'
import ResponsiveImage from '@/components/responsive-image/responsive-image'
import StructuredTextDefault from '@/components/structured-text/structured-text-default'

import * as styles from './styles.module.scss'

const ShowcaseSection = (
  props: Queries.ShowcaseSectionFragment
): ReactElement | null => {
  const { title, subtitle, image, responsiveImage, logoImage, content } = props
  return (
    <div className={`${styles.showcaseSection}`}>
      <Container fluid>
        <Row className={styles.darkRow}>
          <Col>
            <Container>
              <Row className={styles.bgImage}>
                <Col lg={4} className="pt-lg-5 pb-4 mt-5">
                  <img src="/media/icons-showcase.svg" alt="service icons" />
                  <h3>{title}</h3>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <Row className={styles.lightRow}>
          <Col>
            <Container>
              <Row className="justify-content-between align-items-center">
                <Col lg={7} className="pt-5">
                  <h3 className="pb-2">{subtitle}</h3>
                  <StructuredTextDefault content={content} />
                </Col>
                {logoImage !== null && (
                  <Col lg={5} className="d-none d-lg-block">
                    <ResponsiveImage
                      mobile={null}
                      image={logoImage?.gatsbyImageData}
                      alt={logoImage?.alt ?? title}
                    />
                  </Col>
                )}
              </Row>
              <Row>
                <Col lg={12} className={styles.columnImage}>
                  <Animation>
                    <ResponsiveImage
                      image={image?.gatsbyImageData}
                      mobile={responsiveImage?.gatsbyImageData}
                      alt={image?.alt ?? title}
                    />
                  </Animation>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ShowcaseSection

export const query = graphql`
  fragment ShowcaseSection on DatoCmsShowcaseSection {
    __typename
    id
    navigationLabel
    title
    subtitle
    image {
      alt
      gatsbyImageData(width: 1500)
      url
    }
    responsiveImage {
      alt
      gatsbyImageData(width: 750)
      url
    }
    logoImage {
      alt
      gatsbyImageData(width: 450)
      url
    }
    content {
      value
    }
  }
`
